module.exports = __webpack_public_path__ + "img/logo-apple.8dd119af.png";